import React from "react";
import { Context } from "../contexts/context";

export function useEditor() {
	const { editor } = React.useContext(Context);
	return editor;
}
